function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import find from 'lodash/find';
import get from 'lodash/get';
import keys from 'lodash/keys';
import FormContainerAbstract from 'components/FormContainerAbstract';
import Form from 'components/Form';
import FormGroup from 'components/Form/FormGroup';
import CheckboxRadio from 'components/Form/CheckboxRadio';
import Button from 'components/Form/Button';
import App from 'modules/App';
import Account from 'modules/Account';
import * as actions from '../../../actions';
import * as constants from '../../../constants';
import * as selectors from '../../../selectors';
import validatorRules from './validatorRules.json';
class CountryForm extends FormContainerAbstract {
    componentDidUpdate(prevProps) {
        const { isInProgress, hasErrors } = this.props;
        if (prevProps.isInProgress !== isInProgress && !isInProgress && !hasErrors) {
            this.onCommit();
            this.props.onSuccess();
        }
    }
    onCommit() {
        const values = get(this.props.formValues, 'values', {});
        const originalValues = get(this.props.formValues, 'originalValues', {});
        if (originalValues.countryCode && originalValues.countryCode !== values.countryCode && Object.keys(values).length > 1) {
            const ids = keys(values).filter((id)=>id !== 'countryCode');
            this.onUnsetValues(ids);
        }
        super.onCommit();
    }
    onSubmit() {
        this.props.onFormProcessing();
        const { validatedValues, errors } = this.onValidate(this.validatorRules);
        this.props.onFormErrors(errors);
        if (!errors) {
            this.props.onSubmit(validatedValues);
            const { countryCode } = validatedValues;
            const country = find(this.props.countries, {
                alpha2Code: countryCode
            });
            const { defaultLanguageCode } = country;
            this.onSetValues({
                languageCode: defaultLanguageCode
            });
        }
    }
    get countryOptions() {
        return this.props.identities.filter((identity)=>Account.constants.BUSINESS_SCOPES.includes(identity.scope)).map((identity)=>{
            const country = this.props.countries.find((c)=>c.alpha2Code === identity.countryCode);
            return {
                value: country.alpha2Code,
                label: get(this.props.localizationResources, [
                    country.nameKey,
                    'value'
                ], country.englishName)
            };
        }).sort((a, b)=>a.label.localeCompare(b.label));
    }
    renderActions() {
        return /*#__PURE__*/ _jsxs("div", {
            className: "row flex-column-reverse flex-sm-row",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "col-12 col-sm-6",
                    children: /*#__PURE__*/ _jsx(Button, {
                        styleModifier: "primary",
                        labelMessage: App.messages.buttons.cancel,
                        className: "btn--block",
                        isDisabled: this.isInProgress,
                        onClick: this.props.onCancel
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "col-12 col-sm-6",
                    children: /*#__PURE__*/ _jsx(Button, {
                        type: "submit",
                        styleModifier: "primary",
                        labelMessage: App.messages.buttons.next,
                        className: "btn--block btn--filled",
                        isDisabled: this.isDisabled,
                        isInProgress: this.isInProgress
                    })
                })
            ]
        });
    }
    renderCountryOption(countryOption) {
        const { value, label } = countryOption;
        return /*#__PURE__*/ _jsx(FormGroup, {
            id: "countryCode",
            formValues: this.props.formValues,
            children: /*#__PURE__*/ _jsx(CheckboxRadio, {
                inputValue: value,
                labelMessage: label,
                isRadio: true,
                onChange: (input)=>this.onSetValue(input)
            })
        }, value);
    }
    render() {
        return /*#__PURE__*/ _jsxs(Form, {
            onSubmit: ()=>this.onSubmit(),
            children: [
                /*#__PURE__*/ _jsx("div", {
                    children: this.countryOptions.map((countryOption)=>this.renderCountryOption(countryOption))
                }),
                this.renderActions()
            ]
        });
    }
    constructor(props){
        super(props);
        this.validatorRules = _object_spread({}, validatorRules);
    }
}
_define_property(CountryForm, "propTypes", _object_spread_props(_object_spread({}, FormContainerAbstract.propTypes), {
    // Implicit props
    identities: PropTypes.arrayOf(Account.shapes.identity),
    countries: PropTypes.arrayOf(App.shapes.country),
    localizationResources: PropTypes.object,
    // Explicit actions
    onSuccess: PropTypes.func,
    onCancel: PropTypes.func
}));
const mapStateToProps = (state)=>({
        isInProgress: selectors.isFetchOrganizationTemplateInProgress(state),
        hasErrors: selectors.hasFetchOrganizationTemplateErrors(state),
        identities: Account.selectors.identities(state),
        countries: App.selectors.countries(state),
        formValues: App.selectors.formSelector(constants.CREATE_FORM)(state),
        localizationResources: App.selectors.localizationResources(state)
    });
const mapDispatchToProps = (dispatch)=>{
    const formName = constants.CREATE_FORM;
    return {
        onSubmit: ({ countryCode })=>dispatch(actions.fetchOrganizationTemplate(countryCode)),
        onCommitForm: ()=>dispatch(App.actions.commitForm(formName)),
        onSetFormValue: (input)=>dispatch(App.actions.setFormValue(formName, input)),
        onSetFormValues: (values)=>dispatch(App.actions.setFormValues(formName, values)),
        onUnsetFormValues: (ids)=>dispatch(App.actions.unsetFormValues(formName, ids)),
        onFormErrors: (errors)=>dispatch(App.actions.setFormErrors(formName, errors)),
        onFormProcessing: ()=>dispatch(App.actions.startFormProcessing(formName))
    };
};
const ConnectedCountryForm = connect(mapStateToProps, mapDispatchToProps)(CountryForm);
export default ConnectedCountryForm;
